import React from "react";
class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error, info) {
      console.log('error');
      
      this.setState({ hasError: true });
    }
  
    render() {
      if (this.state.hasError) {
        return <h3>Please refresh the page</h3>;
      }
      return this.props.children;
    }
  }

  export default ErrorBoundary;